import React from 'react'

const React_Coding_Practice_28 = () => {
  return (
    <div>
      <h1>Coding Pratice 28</h1>
    </div>
  )
}

export default React_Coding_Practice_28
